<template>
  <div>
    <div class="ts-page-wrapper ts-homepage" id="page-top">
      <TopNav />
      <div style="margin: 200px 0"></div>
      <NewActivity />
      <Footer />
    </div>
  </div>
</template>

<script>
import NewActivity from "../components/NewActivity";
import TopNav from "../components/TopNav";
import Footer from "../components/Footer";

export default {
  name: "NewActivityPage",
  components: {
    NewActivity,
    Footer,
    TopNav,
  },
};
</script>